import React, { Component } from 'react';

import RestorePasswordForm from './components/RestorePasswordForm';

class RestorePassword extends Component {

    componentDidMount() {
        document.title = window.globalVars.pageTitleBefore + "Restore Password" + window.globalVars.pageTitleAfter;
        window.scrollTo({top: 0, left: 0, behavior: "smooth"});
    }

    render() {

        return (
            <div className="restore-password-container">
                <RestorePasswordForm type={this.props.type} />
            </div>
        );

    }

}

export default RestorePassword;



// WEBPACK FOOTER //
// ./src/RestorePassword.js